import { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { providerColor } from "@/components/ProviderAppointmentCard";

function formatCountdown(ms) {
  const abs = Math.abs(ms);
  const mins = Math.round(abs / 60000);
  if (abs < 60000) return ms >= 0 ? "now" : "just now";
  if (mins < 60) return ms >= 0 ? `in ${mins} min${mins === 1 ? "" : "s"}` : `${mins} min${mins === 1 ? "" : "s"} ago`;
  const hours = Math.round(mins / 60);
  return ms >= 0 ? `in ${hours} hr${hours === 1 ? "" : "s"}` : `${hours} hr${hours === 1 ? "" : "s"} ago`;
}

export default function NextUpBanner({ appointments }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);

  const withTimes = (appointments || [])
    .map((a) => ({ ...a, startMs: a.start_iso ? new Date(a.start_iso).getTime() : 0 }))
    .filter((a) => a.startMs > 0)
    .sort((a, b) => a.startMs - b.startMs);

  // Find the first upcoming (or started within last 30 min) appointment
  const next = withTimes.find((a) => (a.startMs - now) > -30 * 60000);
  if (!next) return null;

  const color = providerColor(next.practitioner_id || next.practitioner_name || "");
  const diff = next.startMs - now;

  return (
    <div
      className={`rounded-2xl p-4 border-2 ${color.border} ${color.bg} flex items-start gap-3 shadow-sm`}
      data-testid="next-up-banner"
    >
      <div className={`w-10 h-10 rounded-full ${color.dot} text-white flex items-center justify-center shrink-0`}>
        <Zap className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-[10px] uppercase tracking-widest font-semibold ${color.text}`}>Next up · {formatCountdown(diff)}</p>
        <h3 className="font-display font-semibold text-base truncate">{next.patient_name}</h3>
        <p className={`text-xs ${color.text} truncate`}>
          {next.time || "TBD"} · {next.appointment_type} · {next.practitioner_name}
        </p>
      </div>
    </div>
  );
}
